export class TourConfig {
  public static OPTIONS = {
    classes: 'portal-guide',
    scrollTo: false,
    modalContainer: document.getElementById('scrollableContainer')
  };
}
